import React from 'react';
import classnames from 'classnames';
import { withStyles } from 'theme/withStyles';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import useEmbedPdf from 'hooks/useEmbedPdf';
import { HOME_ROOT } from 'config/api';
import dialogActions from 'core/dialogs/actions';
import dataActions from 'core/data/actions';
import Button from 'common/Button';
import Spinner from 'common/Spinner';

import dialogStyles from './styles/dialog';
import contentStyles from './styles/content';
import bodyStyles from './styles/body';
import footerStyles from './styles/footer';
import noticeStyles from './styles/notice';
import embedPdf from './styles/embedPdf';

const styles = (theme) => {
  const common = {
    body: bodyStyles(theme),
    content: contentStyles(theme),
    dialog: dialogStyles(theme),
    embedPdf: embedPdf(theme),
    footer: footerStyles(theme),
    notice: noticeStyles(theme),
  };
  return {
    ...common,
    content: {
      ...common.content,
      borderLeft: 'none',
      display: 'flex',
    },
    dialog: {
      ...common.dialog,
      height: '90%',
      maxWidth: '100%',
      width: '90%',

      [`@media(max-width: ${theme.screenSizes.mobileMax}px)`]: {
        height: '100%',
        width: '100%',
      },
    },
  };
};

export const HomeAgreementsBare = ({ agreement, classes, close, commonClasses, request }) => {
  useEmbedPdf(`${HOME_ROOT}/${request.id}/agreements/${agreement.agreementId}`, '#embed-pdf', {
    pdfOpenParams: {
      view: 'FitH',
    },
    title: agreement.label,
  });
  const buttons = [
    {
      className: 'btn btn-mobile btn-close btn-i-accept',
      onClick: close,
      text: 'Close',
      variant: 'primary',
    },
  ];

  return (
    <div className={classnames('modal-pdf', commonClasses, classes.dialog)}>
      <div className={classnames('modal-content', classes.content)}>
        <div className={classnames('modal-body', classes.body)} id="modal-body">
          <div>
            <div id="embed-pdf" className={classnames('embed-pdf', classes.embedPdf)} />
          </div>
        </div>
        <div className={classnames('modal-footer', classes.footer)}>
          {buttons.map((b, i) => (
            <Button
              /* eslint-disable-next-line react/no-array-index-key */
              key={`dialog-button-${i}`}
              className={`btn ${b.className} popbox-btn${i}`}
              data-key={i}
              onClick={b.onClick}
              variant={b.variant}
            >
              {b.text}
              {b.className.includes('btn-i-accept') && (
                <>
                  <i className="icon-arrow-thin-right" aria-hidden="true" />
                  <Spinner loading={false} />
                </>
              )}
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
};

HomeAgreementsBare.propTypes = {
  agreement: PropTypes.shape({
    agreementId: PropTypes.string,
    label: PropTypes.string,
  }).isRequired,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  close: PropTypes.func.isRequired,
  commonClasses: PropTypes.string.isRequired,
  request: PropTypes.shape({
    id: PropTypes.number,
  }).isRequired,
};

const mapStateToProps = ({ dialogs }) => ({
  agreement: dialogs.params.agreement,
  request: dialogs.params.request,
});

const mapDispatchToProps = {
  changeFieldValue: dataActions.changeData,
  close: dialogActions.close,
};

const HomeAgreementsStyled = withStyles(styles)(HomeAgreementsBare);

export default connect(mapStateToProps, mapDispatchToProps)(HomeAgreementsStyled);
